import { addAlphaToColor } from '@flowx/core-theme'

import { ShadowToken } from '../../services/theme-model/shadows'

export function getShadowStyles(shadow: ShadowToken, hexColor: string): string {
  const { x, y, blurRadius, spread, color } = shadow
  const { alpha } = color
  return `${x}px ${y}px ${blurRadius}px ${spread}px ${addAlphaToColor(hexColor, alpha)}`
}
